module.exports = __webpack_public_path__ + "img/realshield-logo-blue.79654899.png";